import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
// import logoCrypto from "@/assets/logoCrypto.svg";
import logoCrypto from "@/assets/logoCrypto.png";
import SearchIcon from "@mui/icons-material/Search";
import slogan from "@/assets/sloganCrypto.png";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { AppBar, Box, Grid } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import notificationlogo from "@/assets/inactiveNotification.svg";
import { AccountCircle } from "@material-ui/icons";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import loginIcon from "@/assets/loginIcon.svg";
import dropdownIcon from "@/assets/dropdownIcon.svg";
import world from "@/assets/world.svg";
import AdbIcon from "@mui/icons-material/Adb";
import MenuIcon from "@mui/icons-material/Menu";
import "./CSS/style.css";
import Drawer from "@mui/material/Drawer";
import DehazeRoundedIcon from "@mui/icons-material/DehazeRounded";
import { theme } from "./theme";
declare global {
  interface Window {
    // ⚠️ notice that "Window" is capitalized here
    google: any;
    googleTranslateElementInit: any;
  }
}
const pages = ["Live Lottery", "Lotteries", "Promotions"];
export default function Header() {
  const [showSelector, setShowSelector] = React.useState(false);
  // const sections = [
  //   { title: "ICO", url: "/ICO", id: "0" },
  //   { title: "Promotions", url: "/Promotions", id: "0" },
  // ];

  const sections = [
    { title: "ICO", url: "https://presale.gateway2fortune.com/", id: "0" },
    // { title: "Promotions", url: "/Promotions", id: "0" },
  ];
  
  const googleTranslateElementInit = () => {
    if (!document.getElementById("google_translate_placeholder")) {
      const placeholder = document.createElement("div");
      placeholder.id = "google_translate_placeholder";
      document
        .getElementById("google_translate_element")
        ?.appendChild(placeholder);

      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout:
            window.google.translate.TranslateElement.InlineLayout.VERTICAL,
          autoDisplay: false,
        },
        "google_translate_placeholder"
      );
    }
  };

  React.useEffect(() => {
    const savedLang = localStorage.getItem("preferredLang");
    console.log(savedLang, "savedLang");
    if (!document.querySelector("script[src*='translate_a/element.js']")) {
      const addScript = document.createElement("script");
      addScript.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.body.appendChild(addScript);
      (window as any).googleTranslateElementInit = googleTranslateElementInit;
    } else {
      googleTranslateElementInit(); // init again if script already loaded
    }

    const observer = new MutationObserver(() => {
      const select = document.querySelector<HTMLSelectElement>(
        "select.goog-te-combo"
      );
      if (select) {
        if (savedLang) {
          select.value = savedLang;
          select.dispatchEvent(new Event("change"));
          document.getElementById("google_translate_element")!.style.display =
            "none";
        } else {
          setShowSelector(true);
          const onChange = (e: Event) => {
            const value = (e.target as HTMLSelectElement).value;
            if (value) {
              localStorage.setItem("preferredLang", value);
              setTimeout(() => {
                document.getElementById(
                  "google_translate_element"
                )!.style.display = "none";
                setShowSelector(false);
              }, 500);
              select.removeEventListener("change", onChange);
            }
          };
          select.addEventListener("change", onChange);
        }
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const interval = setInterval(() => {
      const isTranslated =
        document.querySelector("html")?.getAttribute("lang") !== "en";
      const banner = document.querySelector(".goog-te-banner-frame");

      if (!banner && savedLang && !isTranslated) {
        localStorage.removeItem("preferredLang");
        setShowSelector(true);
        document.getElementById("google_translate_element")!.style.display =
          "block";
      }
    }, 1000);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorElLang, setAnchorElLang] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const open = Boolean(anchorEl);
  const openLang = Boolean(anchorElLang);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickLang = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElLang(event.currentTarget);
  };
  const handleCloseLang = () => {
    setAnchorElLang(null);
  };
  const [sideBarOpen, setSideBarOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setSideBarOpen(newOpen);
  };
  const [scrolled, setScrolled] = React.useState(false);
  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
        // Call your function here
        console.log("Scrolled more than 20px");
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <React.Fragment>
      <AppBar
        position="fixed"
        color="default"
        elevation={0}
        sx={{
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          background: scrolled
            ? "rgba(19, 20, 32, 1)"
            : "rgba(19, 20, 32, 0.4)",
          zIndex: "2",
          minHeight: "fit-content !important",
          [theme.breakpoints.down("sm")]: {
            position: "sticky",
            top: 0,
          },
        }}
      >
        <Toolbar
          sx={{
            flexWrap: "wrap",
            my: "0px",
            py: "0px",
            justifyContent: "space-between",
            gap: "10px",
            minHeight: "auto !important",
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            flexGrow={{ sm: 1, md: 0 }}
            sx={{ background: "transparent", maxWidth: "33.33%" }}
          >
            <Button
              onClick={toggleDrawer(true)}
              sx={{
                boxSizing: "border-box",
                width: "35px",
                minWidth: "fit-content",
                marginInlineStart: "0px",
                paddingInlineStart: "0px",
                "@media screen and (min-width:992px)": { display: "none" },
              }}
            >
              <DehazeRoundedIcon sx={{ color: "#fff", fontSize: "35px" }} />
            </Button>
            <Link
              variant="h3"
              href="/"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <img
                src={logoCrypto}
                alt="logo"
                className="logoImage"
                loading="lazy"
              />
            </Link>
            <Box
              sx={{ display: { xs: "none", md: "flex", alignItems: "center" } }}
            >
              {sections.map((section) => (
                <Link
                  variant="button"
                  color="text.primary"
                  key={section.title}
                  href={section.url}
                  target={section.title === "ICO" ? "_blank" : undefined}
                  rel={section.title === "ICO" ? "noopener noreferrer" : undefined}
                  textAlign="center"
                  underline="none"
                  sx={{ my: 1, mx: 1.5, color: "#ffff" }}
                >
                  {section.title}
                </Link>
              ))}
            </Box>
          </Box>
          <Box
            className="img-landscape-mid-logo"
            sx={{
              display: { sm: "flex", xs: "none" },
              justifyContent: "center",
              flexGrow: { sm: 1, md: 0 },
              maxWidth: "33.33%",
            }}
          >
            <img src={slogan} alt="slogan" loading="lazy" />
          </Box>
          <Box
            sx={{
              display: "flex !important",
              alignItems: "center",
              gap: "5px",
              flexGrow: { sm: 1, md: 0 },
              justifyContent: "flex-end",
              maxWidth: "33.33%",
            }}
          >
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-haspopup="true"
              color="inherit"
              sx={{ padding: "0px 5px" }}
            >
              <img src={loginIcon} alt="login icon" loading="lazy"></img>
            </IconButton>
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "400px",
                  mr: "9px",
                  textTransform: "capitalize",
                }}
              >
                Login
              </Typography>{" "}
              <img src={dropdownIcon} alt="login icon" loading="lazy"></img>
            </Button>
            <Menu
              id="basic-menu "
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={handleClose}>
                <Link href="/auth/login" underline="none">
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: "400px", fontStyle: "normal" }}
                  >
                    Login
                  </Typography>
                </Link>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <Link href="/auth/register" underline="none">
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: "400px", fontStyle: "normal" }}
                  >
                    Sign up
                  </Typography>
                </Link>
              </MenuItem>
            </Menu>
            <Box className="languageChangeBtn" sx={{ margin: "0px" }}>
              <div
                id="google_translate_element"
                style={{ display: showSelector ? "block" : "none" }}
              />
              {!showSelector && (
                <button
                  onClick={() => {
                    localStorage.removeItem("preferredLang");
                    setShowSelector(true);
                    document.getElementById(
                      "google_translate_element"
                    )!.style.display = "block";
                  }}
                >
                  Change Language
                </button>
              )}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        open={sideBarOpen} // Use `open` instead of `sideBarOpen`
        onClose={toggleDrawer(false)} // `onClose` will toggle the drawer closed
        sx={{
          "& .MuiDrawer-paper": {
            background: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <Box className="sideTray">
          <Box className="sideTarayHeader">
            <Link variant="h3" href="/app">
              <img
                src={logoCrypto}
                alt="logo"
                className="logoImage"
                loading="lazy"
              />
            </Link>
          </Box>
          <Box className="mobileMenu" sx={{ height: "100%" }}>
            <ul className="mobileMenuList">
              {sections.map((section, i) =>
                section.id != "5" ? (
                  <li>
                    <Link
                      variant="button"
                      color="text.primary"
                      key={section.title}
                      href={section.url}
                      target={section.title === "ICO" ? "_blank" : undefined}
                      rel={section.title === "ICO" ? "noopener noreferrer" : undefined}
                      textAlign="center"
                      underline="none"
                      sx={{ my: 1, mx: 1.5, color: "#ffff" }}
                    >
                      {section.title}
                    </Link>
                  </li>
                ) : (
                  <></>
                )
              )}
              <li></li>
            </ul>
          </Box>
        </Box>
      </Drawer>
    </React.Fragment>
  );
}
